<template>
  <div class="text-left">
    <label class="font-weight-black mb-3">Carrito seleccionado</label>
    <v-chip class="py-5 py-2 w-100" height="30px" label outlined>
      <v-icon
        left
        size="20px"
        class="cursor-pointer"
        @click="$emit('unselect')"
      >
        mdi-close-circle
      </v-icon>
      <div>{{ orderName }}</div>
    </v-chip>
  </div>
</template>
<script>
  export default {
    name: 'SelectedOrderChip',

    props: {
      orderName: {
        type: String,
        default: null,
      },
    },
  };
</script>
